module.exports = __webpack_public_path__ + "static/img/camera-1.1ab0f05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/detailpic/camera/camera-1.jpg
// module id = e2oJ
// module chunks = 51